// W.5: czyste funkcje (bez React/axios) do obsługi wyniku podglądu importu
// (kontrakt Login/backend/routes/import.js — rows[].{data,rowNumber,errors,warnings,action}).

// Excel/Sheets interpretuje komórkę zaczynającą się od =, +, -, @ jako formułę —
// prefiks apostrofem neutralizuje to przy otwieraniu wygenerowanego CSV.
const CSV_FORMULA_PREFIX = /^[=+\-@]/;

function csvCell(value) {
  let str = value == null ? '' : String(value);
  if (CSV_FORMULA_PREFIX.test(str)) str = `'${str}`;
  str = str.replace(/"/g, '""');
  if (/[";\n\r]/.test(str)) str = `"${str}"`;
  return str;
}

// CSV błędnych wierszy do pobrania — separator ';' + BOM UTF-8, żeby Excel PL
// otworzył plik poprawnie (domyślny ',' Excel PL traktuje jako część liczby).
export function buildErrorReportCsv(rows) {
  const header = ['Wiersz w arkuszu', 'Pole', 'Komunikat'];
  const lines = [header.map(csvCell).join(';')];
  (rows || []).forEach((row) => {
    if (row.action !== 'invalid') return;
    (row.errors || []).forEach((err) => {
      lines.push([row.rowNumber, err.field, err.message].map(csvCell).join(';'));
    });
  });
  const BOM = '﻿';
  return BOM + lines.join('\r\n');
}

// Wiersze z ostrzeżeniami (np. powtórzony telefon) — import ich NIE blokuje,
// pokazywane osobno od błędów niezależnie od `action`.
export function buildWarningRows(rows) {
  return (rows || []).filter((row) => Array.isArray(row.warnings) && row.warnings.length > 0);
}

export function splitRowsByAction(rows) {
  const toInsert = [];
  const toUpdate = [];
  const invalid = [];
  (rows || []).forEach((row) => {
    if (row.action === 'invalid') invalid.push(row);
    else if (row.action === 'update') toUpdate.push(row);
    else toInsert.push(row);
  });
  return { toInsert, toUpdate, invalid };
}
